import script from "./JetAPIChatFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./JetAPIChatFrame.vue?vue&type=script&setup=true&lang=js"

import "./JetAPIChatFrame.vue?vue&type=style&index=0&id=5caebbd1&lang=css"

const __exports__ = script;

export default __exports__